import * as React from "react"
import { AiOutlineMenu } from "react-icons/ai";
import styled from "styled-components";

const MenuIcon = styled(AiOutlineMenu)`
  font-size: ${p => p.small ? 18 : 26}px;
  font-weight: ${p => p.bold ? 900 : 500};
  cursor: pointer;
  margin: auto 5px auto auto;
  
  &:hover, &:focus{
    color: orange
  }
`

const OutlineMenuIcon = ({small = false, bold = false, onClick}) => {
  return (
      <MenuIcon small={small} bold={bold} onClick={onClick}/>
  )
}

export default OutlineMenuIcon